export default {
    getCurrenciesData: function(state) {
        return state.currencies;
    },
    getTariffsData: function (state) {
        return state.tariffs;
    },
    getTariffDetails: function (state) {
        return state.tariff_details;
    },
}